import { FC } from 'react';
import { Divider } from '../../../atoms/divider/divider';
import { Typography } from '../../../ui';

type Props = {
  date: string;
};

export const ChangedAssigneeUnassignedDivider: FC<Props> = (props) => {
  const { date } = props;

  return (
    <Divider>
      <div className="flex items-center space-x-8">
        <Typography
          variant="body-xs"
          weight="regular"
          className="text-grayscale400 text-nowrap"
        >
          Toewijzing verwijderd
        </Typography>

        <Typography
          variant="body-xxs"
          weight="regular"
          className="text-grayscale300 text-nowrap"
        >
          {date}
        </Typography>
      </div>
    </Divider>
  );
};
